import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Button, Tooltip } from 'Permafrost/index';
import { StyledTabs } from './TabbedInterface.styles';
/**
 * Abstract/utility component which should **not** be used directly. Instead, use components:
 * - `TabNavigation` to navigate between URLs
 * - `TabbedContainer` to switch between blocks of content
 */
export function TabbedInterface(props) {
    const { children, className, currentTab, fullWidthTabs, id, onTabSelect, tabs, tabType } = props;
    // const [current, setCurrent] = useState<string>(currentTab || tabs[0].id);
    const handleTabSelect = (id) => {
        if (!!onTabSelect) {
            onTabSelect(id);
        }
        // setCurrent(id);
    };
    const navigationTab = (props) => {
        const { id, name, route } = props;
        return (React.createElement(Link, { className: "TabbedInterface__tablist-link", to: route, role: "tab", "aria-selected": id === currentTab, id: id, onClick: () => handleTabSelect(id) }, name));
    };
    const sectionTab = (props) => {
        const { id, name, disabled, tooltip } = props;
        return (React.createElement(React.Fragment, null,
            disabled ? (React.createElement(Tooltip, { for: `${id}-tab`, block: true }, tooltip)) : null,
            React.createElement(Button, { "data-tip": true, "data-for": `${id}-tab`, disabled: disabled, role: "tab", variant: "no-style", "aria-selected": id === currentTab, id: id, onClick: () => handleTabSelect(id), className: fullWidthTabs ? 'fullWidthTabs' : '' }, name)));
    };
    const tabStyle = (tabQuantity) => {
        return { flexBasis: `${100 / tabQuantity}%` };
    };
    return (React.createElement("div", { className: classNames('tabbedInterface', className), "data-cy": props['data-cy'], id: id, style: { paddingBottom: '2em' } },
        React.createElement(StyledTabs, { role: "tablist" }, tabs.map((tab) => (React.createElement("li", { key: tab.id, role: "presentation", style: fullWidthTabs ? tabStyle(tabs.length) : {} }, tabType === 'navigation'
            ? navigationTab(tab)
            : sectionTab(tab))))),
        React.createElement("div", { role: "tabpanel", "aria-labelledby": currentTab }, children)));
}
//# sourceMappingURL=TabbedInterface.js.map